import { Link } from "react-router-dom";
import { Linkedin, Mail, ArrowUpRight } from "lucide-react";
import { SITE, NAV_LINKS } from "@/lib/site";
import BrandMark from "@/components/site/BrandMark";

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer
      data-testid="site-footer"
      className="bg-brand-navy text-white"
    >
      <div className="container-tight py-20 md:py-28">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12">
          <div className="lg:col-span-6">
            <p className="overline text-[#E8A487]">Let's talk</p>
            <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl tracking-tight leading-[1.1] mt-5 text-white text-balance">
              Ready for a calmer, more predictable transformation?
            </h2>
            <p className="mt-6 text-base md:text-lg text-white/70 max-w-xl leading-relaxed">
              The first step is a short, confidential discovery call. No pitch, no obligation — just a focused conversation about where you are and where you want to go.
            </p>
            <Link
              to="/contact"
              data-testid="footer-cta-book"
              className="mt-10 inline-flex items-center gap-2 bg-white text-brand-ink px-6 py-3.5 text-sm font-medium tracking-wide transition-all duration-200 hover:bg-[#E8A487] hover:text-brand-ink hover:-translate-y-[1px]"
            >
              Book a Discovery Call
              <ArrowUpRight className="h-4 w-4" strokeWidth={1.5} />
            </Link>
          </div>

          <div className="lg:col-span-2">
            <p className="overline text-[#E8A487]">Navigate</p>
            <ul className="mt-6 space-y-3">
              {NAV_LINKS.map((l) => (
                <li key={l.to}>
                  <Link
                    to={l.to}
                    data-testid={`footer-nav-${l.label.toLowerCase()}`}
                    className="text-sm text-white/80 hover:text-white transition-colors"
                  >
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-4">
            <p className="overline text-[#E8A487]">Contact</p>
            <ul className="mt-6 space-y-4">
              <li>
                <a
                  href={`mailto:${SITE.email}`}
                  data-testid="footer-email-link"
                  className="group inline-flex items-center gap-3 text-sm text-white/85 hover:text-white transition-colors"
                >
                  <Mail className="h-4 w-4 text-[#E8A487]" strokeWidth={1.5} />
                  {SITE.email}
                </a>
              </li>
              <li>
                <a
                  href={SITE.linkedin}
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid="footer-linkedin-link"
                  className="group inline-flex items-center gap-3 text-sm text-white/85 hover:text-white transition-colors"
                >
                  <Linkedin className="h-4 w-4 text-[#E8A487]" strokeWidth={1.5} />
                  LinkedIn — Anna Zavarzina
                </a>
              </li>
            </ul>
            <p className="mt-8 text-xs text-white/50 leading-relaxed max-w-xs">
              Engagements are confidential. All initial conversations are exploratory and without obligation.
            </p>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-white/10 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
          <div className="flex items-center gap-3">
            <BrandMark size={32} dark="#FFFFFF" accent="#E8A487" />
            <p className="text-sm text-white/70">
              © {year} {SITE.brand}. All rights reserved.
            </p>
          </div>
          <div className="flex items-center gap-6 text-xs text-white/50">
            <span data-testid="footer-title">{SITE.name} — {SITE.title}</span>
            <a
              href="/privacy"
              data-testid="footer-privacy-link"
              className="hover:text-white/80 transition-colors"
            >
              Privacy
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
